import React, {Component} from 'react'
import {Spin} from 'antd'
import PartnerRow from './table/PartnerRow'
import PropTypes from "prop-types"

class PartnersTable extends Component {
    render() {
        const cols = ['Tên đối tác', 'Loại đối tác', 'Ngày tạo', 'Số lô ', 'Hành động']
        const {loading, partners} = this.props

        return (
            <div className="PartnersTable">
                <Spin spinning={loading} tip='Đang tải...'>
                    <table className='table table-borderless table-striped'>
                        <thead className='thead-light'>
                        <tr>
                            {
                                cols.map((item, index) => {
                                    return <th key={index}>{item}</th>
                                })
                            }
                        </tr>
                        </thead>
                        <tbody>
                        {
                            partners.length > 0 ? (
                                <PartnerRow {...this.props}/>
                            ) : (
                                <tr>
                                    <td colSpan={cols.length}>Không có dữ liệu</td>
                                </tr>
                            )
                        }
                        </tbody>
                    </table>
                </Spin>
            </div>
        )
    }
}

PartnersTable.propTypes = {
    loading: PropTypes.bool.isRequired,
    partnerURL: PropTypes.string,
    partners: PropTypes.array.isRequired
}

export default PartnersTable